<template>
    <div class="fzxw">
        <div class="content">
            <div class="xq">
                <img class="banner_img" src="../../static/img/chanpin_banner.png" alt="">
                <div class="xq_1 w1200" v-for="(item,i in fsImg" :key="i"  v-if="$route.query.id - 0 === i">
                   <img :src="item.imgs" alt="">
                </div>
                <div class="xq_4 w1200">
                    <h3>03 问题解答</h3>
                    <div class="xq_text">
                        <div class="yw" v-for=" (item, i ) in wtjd" :key="i">
                            <h4 class="ytext" @click="active2 = i">
                                {{item.text}}
                            </h4>
                            <p :class="{ click: active2 === i }"> {{item.value}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Footers from '../components/Footer.vue'
export default {
  name: 'fzxw',
  components: {
    // Footers
  },
  data () {
    return {
      active3: false,
      active2: null,
      active: 0,
      wtjd: [
        {
          text: 'Q：意外伤害包含哪些？',
          value: 'A：意外伤害指以外来的、突发的、非本意的、非疾病的客观事件为直接且单独的原 因致使身体受到的伤害。'
        },
        {
          text: 'Q:如何选择适合自己的保险计划？',
          value: 'A：建议个人意外保额应为个人收入至少80%的水平并可维持10年以上的基本生活。举例来说，年收入20万推荐购买200万保额的意外险。'
        },
        {
          text: 'Q:如果保险期间发生伤残理赔，是否还可以续保？',
          value: 'A：如果保险年度内，伤残责任理赔金额累计达到本项责任限额，则保险合同终止，且不再接受续保。如果发生伤残理赔，但理赔金额未达到本项责任限额，则可以继续续保。'
        },
        {
          text: 'Q:合同期满后，如何续保？',
          value: 'A：保险合同期满前30天，前15天，期满日当天和期满日后10天将通过短信发送投保链接给投保人，只要在期满前30天到期满日后15天内，点击投保链接，完成付款即可完成续保。'
        },
        {
          text: 'Q：投保成功后，如何查询保单？',
          value: 'A：若投保人留存了电子邮箱， 承保后电子保单会直接发到所留的电子邮箱。'
        }
      ],
      fsImg: [
        {
          imgs: require('../../static/img/gdym-xq.png'),
          id: '0'
        },
        {
          imgs: require('../../static/img/tfqq-xq.png'),
          id: '1'
        },
        {
          imgs: require('../../static/img/xtrs-xq.png'),
          id: '2'
        }, {
          imgs: require('../../static/img/gyas-xq.png'),
          id: '3'
        },
        {
          imgs: require('../../static/img/ccrs-xq.png'),
          id: '4'
        },
        {
          imgs: require('../../static/img/hxrs-xq.png'),
          id: '5'
        }, {
          imgs: require('../../static/img/jkrs-xq.png'),
          id: '6'
        },
        {
          imgs: require('../../static/img/fxlh-xq.png'),
          id: '7'
        }
      ]
    }
  },
  methods: {
    fsxz () {
      this.active3 ? this.active3 = false : this.active3 = true
    },
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  },
  mounted() {
      let id = this.$route.query.id
      if(this.isMobile()) {
        this.$router.push({path:'/fsproducts?id=', query: {id:id}})
        } else {
        this.$router.push({path:'/cpxq?page=3&id=', query: {id: id}})
        }
  }
}
</script>
<style lang="scss" scoped>
.fzxw{
    position: relative;
}
.content {
    position: relative;
    max-width: 19.2rem;
    width: 100%;
    margin: 0 auto;
    background-color: #f2f2f2;
    .xq {
        margin: 0 auto;
        background-color: #fff;
        // padding-bottom: 50px;
        .xq_1 {
            position: absolute;
            width: 12rem;
            background-color: #fff;
            left: 0;
            right: 0;
            margin: 0 auto;
            top:-2.5rem;
            position: relative;
            overflow: hidden;
            z-index: 1;
            img{
                margin: 0 auto;
                float: right;
            }
        }
        .xq_4 {
            position: relative;
            top: -1rem;
            h3 {
                background-color: #014fa2;
                height: .7rem;
                line-height: .7rem;
                font-size: .36rem;
                color: #fff;
                padding-left: .35rem;
            }
            .xq_text {
                color: #dc1124;
                width: 11.25rem;
                margin: .5rem auto;
                box-shadow: 0px 0px 3px 3px #fafafa;
                font-size: .3rem;
                padding-left: .25rem;
                h4 {
                    line-height: .74rem;
                    cursor: pointer;
                }
                .yw p {
                    height: 0;
                    overflow: hidden;
                    transition: all 0.3s;
                    color: #0755aa;
                }
                .yw .click {
                    height: auto;
                    overflow: auto;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Cpxq.vue